module.exports = __webpack_public_path__ + "img/yuliango.83c6b7f8.png";